import { useAuth } from './useAuth';
import { usePushNotifications } from './usePushNotifications';
import { usePushState } from '../utils/push-state';
import { pushNudgeState, type PushNudge } from '../utils/push-nudge';
import type { PushSource } from '../services/pushNotification';

export interface UsePushNudgeReturn {
  nudge: PushNudge;
  /** The signed-in account, which the nudges' own storage is keyed by. */
  userId: string | null;
  enable: (source: PushSource) => Promise<void>;
  busy: boolean;
}

/** Whether to ask the signed-in member to turn push on: see `pushNudgeState`. */
export function usePushNudge(): UsePushNudgeReturn {
  const { user } = useAuth();
  const push = usePushNotifications();
  const state = usePushState();

  return {
    nudge: pushNudgeState(user, state),
    userId: user ? String(user.id) : null,
    enable: push.enableNotifications,
    busy: push.isLoading,
  };
}
